// import Basic from './Components/Basic';
import Taskpage from './Components/Taskpage';
import './App.css';

function App() {
  return (
    <div>
       {/* <Basic/> */}
       <Taskpage />
    </div>
  );
}

export default App;
